import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import user from '../images/ic_account_circle.png';


const UserCard = (props) => {
    const classes = useStyles();
    const name = "Jane Doe";
    const birthdate="Jan 1, 1990";
    let cardContent;
    if (props.user.accessLevel === "1") {
        cardContent = (<div class="medContainer">
            <div class = "parental-access-only">{props.strings.PARENTAL_ACCESS_ALERT_HEADER}</div>
        </div>);
    }
    return (
      <div className="user-banner-right">
        <div class="userIcon"><img src={user} width="40" /></div>
          <h5>{props.user.firstName + " " + props.user.lastName}</h5>
          <div class="medContainer">
            <div class="med">{props.strings.USERCARD_LOGGED_IN}</div>
            <div class="medNumber"><b>{props.user.email}</b></div>
          </div>
          {cardContent}
          {/* <p class="dob">{formatDateOfBirth(props.user.dateOfBirth, props.language)}</p> */}
      </div>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        isLoadingLabResults: state.api.isLoadingLabResults,
        isLoadingUsers: state.api.isLoadingUsers,
        user: state.api.user,
        labResults: state.api.labResults,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isError: state.api.isError,
    }
}
const ConnectedUserCard = connect(
    mapStateToProps
)(UserCard);

export default withRouter(ConnectedUserCard);

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        minWidth: 275
    },
    pos: {
        marginBottom: 12
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 275
    },
    icon: {
        fontSize: 50
    }
}));
